import { axiosInstance } from './axios'

export const createUserApi = (data) => {
  return axiosInstance.post('/api/user/create-user', data)
}

export const getUserList = (data) => {
  return axiosInstance.post('/api/user/get-users-list', data)
}

export const getConsultantList = (data) => {
  return axiosInstance.post('/api/user/get-consultant-list', data)
}

export const getFreeConsultant = (data) => {
  return axiosInstance.post('/api/user/get-free-consultant', data)
}

export const resendOtpApi = (data) => {
  return axiosInstance.post('/api/user/resend-otp', data)
}

export const loginApi = (data) => {
  return axiosInstance.post('/api/login', data)
}

export const createMessage = (data) => {
  return axiosInstance.post('/api/message/create-message', data)
}

export const saveOfflineList = (list) => {
  return axiosInstance.post('/api/message/save-offline-msg-list', list)
}

export const fetchMessage = (data) => {
  return axiosInstance.post('/api/message/fetch-messages', data)
}

// export const fetchMessagePagination = (data) => {
//   return axiosInstance.post('/api/message/fetch-messages-pagination', data)
// }

export const assignedUserApi = (data) => {
  return axiosInstance.post('/api/user/assignUser', data)
}

export const updateConsultantStatus = (data) => {
  return axiosInstance.post('/api/user/update-consultant-status', data)
}

export const getUserApi = (data) => {
  return axiosInstance.post('/api/user/getUser', data)
}

export const addAssignedUserApi = (data) => {
  return axiosInstance.post('/api/user/updateAssignedUser', data)
}

export const unassignUser = (data) => {
  return axiosInstance.post('/api/user/unassignUser', data)
}

export const createConsultant = (data) => {
  return axiosInstance.post('/api/user/create-consultant', data)
}

export const addContent = (data) => {
  return axiosInstance.post('/api/content/addContent', data)
}

export const getContent = () => {
  return axiosInstance.get('/api/content/getContent')
}

export const getContentbyId = (id) => {
  return axiosInstance.get(`/api/content/get-Content/${id}`)
}

export const updateOneContent = (data) => {
  return axiosInstance.post('/api/content/updateContents', data)
}

export const deleteContentbyId = (id) => {
  return axiosInstance.delete(`/api/content/deleteContent/${id._id}`)
}

export const addContentIn = (data) => {
  return axiosInstance.post('/api/contentIn/addContentIn', data)
}

export const getContentIn = () => {
  return axiosInstance.get('/api/contentIn/getContentIn')
}

export const getContentbyIdIn = (id) => {
  return axiosInstance.get(`/api/contentIn/get-ContentIn/${id}`)
}

export const updateOneContentIn = (data) => {
  return axiosInstance.post('/api/contentIn/updateContentsIn', data)
}

export const deleteContentbyIdIn = (id) => {
  return axiosInstance.delete(`/api/contentIn/deleteContentIn/${id._id}`)
}

export const addSos = (data) => {
  return axiosInstance.post('/api/sos/addSos', data)
}

export const getSos = () => {
  return axiosInstance.get('/api/sos/getSos')
}

export const getSosbyId = (id) => {
  return axiosInstance.get(`/api/sos/get-Sos/${id}`)
}

export const updateOneSos = (data) => {
  return axiosInstance.post('/api/sos/updateSoss', data)
}

export const deleteSosbyId = (id) => {
  return axiosInstance.delete(`/api/sos/deleteSos/${id._id}`)
}

export const addSosIn = (data) => {
  return axiosInstance.post('/api/sosIn/addSosIn', data)
}

export const getSosIn = () => {
  return axiosInstance.get('/api/sosIn/getSosIn')
}

export const getSosbyIdIn = (id) => {
  return axiosInstance.get(`/api/sosIn/get-SosIn/${id}`)
}

export const updateOneSosIn = (data) => {
  return axiosInstance.post('/api/sosIn/updateSossIn', data)
}

export const deleteSosbyIdIn = (id) => {
  return axiosInstance.delete(`/api/sosIn/deleteSosIn/${id._id}`)
}

export const deleteConsultant = (data) => {
  return axiosInstance.post('/api/user/delete-user', data)
}

export const updateUsers = (data) => {
  return axiosInstance.post('/api/user/update-user', data)
}
export const updateConsultant = (data) => {
  return axiosInstance.post('/api/user/update-consultant', data)
}

export const transferChat = (data) => {
  return axiosInstance.post('/api/user/transfer-user', data)
}

export const getConsultant = (id) => {
  return axiosInstance.post('/api/user/get-consultant', { id })
}

export const uploadFile = (formdata) => {
  return axiosInstance.post('/api/user/upload', formdata)
}

export const uploadBackImages = (formdata) => {
  return axiosInstance.post('/api/user/upload/backgroundImages', formdata)
}

export const changePassword = (data) => {
  return axiosInstance.post('/api/user/changePassword', data)
}

export const validateOtpApi = (data) => {
  return axiosInstance.post('/api/user/validate-otp', data)
}

export const createFeedback = (data) => {
  return axiosInstance.post('/api/feedback/create-feedback', data)
}

export const getAssignedUserCount = (id) => {
  return axiosInstance.post('/api/user/assigned-user-count', id)
}

export const getMessagesCount = (id) => {
  return axiosInstance.post('/api/message/get-messages-count', id)
}

export const getFeedbackCount = (id) => {
  return axiosInstance.post('/api/feedback/get-count', id)
}

export const getAllFeedbackCount = (data) => {
  return axiosInstance.post('/api/feedback/all-feedback-count', data)
}

export const getAverageTime = (id) => {
  return axiosInstance.post('/api/user/get-chat-avg-time', id)
}
export const getOneEndUser = () => {
  return axiosInstance.post('/api/user/getOneEndUser')
}
export const fetchAllMessage = (data) => {
  return axiosInstance.post('/api/message/fetch-all-messages', data)
}
export const fetchFeedback = (data) => {
  return axiosInstance.post('/api/feedback/fetch-all-feedback', data)
}
export const fetchFeedbacks = (data) => {
  return axiosInstance.post('/api/feedback/fetch-all-feedbacks', data)
}
export const fetchUsersPerDay = (data) => {
  return axiosInstance.post('/api/user/fetch-data-user', data)
}

export const forgotPasswordConsultantApi = (id) => {
  return axiosInstance.post('/api/user/forgot-password-consultant', id)
}

export const resetRequest = (email) => {
  return axiosInstance.post('/api/user/reset-consultant-password', email)
}

export const fetchChat = (data) => {
  return axiosInstance.post('/api/message/fetch-chat', data)
}

export const fetchUserIdOfConsultant = (data) => {
  return axiosInstance.post('/api/user/assigned-user-of-consultant', data)
}

export const getConsultantName = (id) => {
  return axiosInstance.post('/api/user/get-consultant-name', id)
}

export const getUsers = (condition, sort) => {
  return axiosInstance.post('/api/user/get-unassigned-users', condition, sort)
}

export const getAllUserCount = (condition, sort) => {
  return axiosInstance.post('/api/user/get-all-users-count', condition, sort)
}

export const getAppUserCount = () => {
  return axiosInstance.get('/api/user/get-app-users-count')
}

export const getAllConsultantCount = (condition, sort) => {
  return axiosInstance.post('/api/user/get-all-consultant-count', condition, sort)
}

export const getAllMessageCount = (condition, sort) => {
  return axiosInstance.post('/api/message/all-msg-count', condition, sort)
}

export const getSiteAvailable = () => {
  return axiosInstance.post('/api/user/get-site-avaliable')
}

export const updateSiteAvailable = (data) => {
  return axiosInstance.post('/api/user/update-site-avaliable', data)
}

export const getUsersPagination = (data) => {
  return axiosInstance.post('/api/user/get-userlist-pagination', data)
}

export const getHistoryPagination = (data) => {
  return axiosInstance.post('/api/user/get-history-pagination', data)
}

export const getHistoryPaginationByFilter = (data) => {
  return axiosInstance.post('/api/user/get-filter-history-pagination', data)
}
